<template>
  <div class="wrapper">
    <side-bar>
      <template slot="links">

        <sidebar-item
          :link="{name: 'Crear Usuarios',path: '/user-create',icon: 'ni ni-single-02 text-default',}">
        </sidebar-item>
        <sidebar-item
          :link="{name: 'Listado Usuarios',path: '/user-list',icon: 'ni ni-bullet-list-67 text-default',}">
        </sidebar-item>
        <sidebar-item
          :link="{name: 'Listado de Agentes',path: '/agent-list',icon: 'ni ni-briefcase-24 text-default',}">
        </sidebar-item>
        <sidebar-item
          :link="{name: 'Tarjeta GO',path: '/tarjeta-go-list',icon: 'ni ni-credit-card text-default',}">
        </sidebar-item>
        <sidebar-item
          :link="{name: 'Crear Notificaciones',path: '/notifications-create',icon: 'ni ni-bell-55 text-default',}">
        </sidebar-item>
        <sidebar-item
          :link="{name: 'Listado Notificaciones',path: '/notifications',icon: 'ni ni-send text-default',}">
        </sidebar-item>
        <sidebar-item
          :link="{name: 'Legal',path: '/faqs',icon: 'fas fa-question'}">
        </sidebar-item>
        <sidebar-item
          :link="{name: 'Noticias',path: '/news',icon: 'fas fa-newspaper'}">
        </sidebar-item>
        <sidebar-item
          :link="{name: 'Soporte',path: '/support',icon: 'fas fa-envelope'}">
        </sidebar-item>
        <sidebar-item
          :link="{name: 'Cerrar Sesion',path: '/login',icon: 'ni ni-button-power text-default',}">
        </sidebar-item>
      </template>
    </side-bar>
    <div class="main-content">
      <dashboard-navbar :type="$route.meta.navbarType"></dashboard-navbar>

      <div @click="$sidebar.displaySidebar(false)">
        <fade-transition :duration="200" origin="center top" mode="out-in">
          <router-view></router-view>
        </fade-transition>
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable no-new */
import PerfectScrollbar from 'perfect-scrollbar';
import 'perfect-scrollbar/css/perfect-scrollbar.css';

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`);
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbar(className);
    }, 100);
  }
}

import DashboardNavbar from './DashboardNavbar.vue';
import ContentFooter from './ContentFooter.vue';
import DashboardContent from './Content.vue';
import {FadeTransition} from 'vue2-transitions';

export default {
  components: {
    DashboardNavbar,
    ContentFooter,
    DashboardContent,
    FadeTransition
  },
  methods: {
    initScrollbar() {
      let isWindows = navigator.platform.startsWith('Win');
      if (isWindows) {
        initScrollbar('sidenav');
      }
    }
  },
  mounted() {
    this.initScrollbar()
  }
};
</script>
<style lang="scss">
</style>
